import { useLocation, useNavigate } from 'react-router-dom';
import { PROSPECT_PORTAL_STEPS } from '../../constants/prospectPortalSteps';
import { usePageProgressByHref } from '../../contexts/ProspectPageProgressContext';
import { isImpersonationPathname, logicalPortalPath, portalHref } from '../../utils/portalPaths';

/**
 * Fixed bottom-right control. It is clickable only when every sub-step of the
 * current major step is complete.
 */
export default function ProspectNextSectionButton({ currentPath }: { currentPath: string }) {
  const navigate = useNavigate();
  const location = useLocation();
  const impersonating = isImpersonationPathname(location.pathname);
  const logicalPath = logicalPortalPath(currentPath);
  const progressByHref = usePageProgressByHref();
  const index = PROSPECT_PORTAL_STEPS.findIndex((step) => step.href === logicalPath);
  if (index < 0 || index >= PROSPECT_PORTAL_STEPS.length - 1) return null;

  const progress = progressByHref[logicalPath];
  const complete = Boolean(progress && progress.total > 0 && progress.completed >= progress.total);

  return (
    <button
      type="button"
      disabled={!complete}
      onClick={() => {
        if (!complete) return;
        navigate(portalHref(PROSPECT_PORTAL_STEPS[index + 1].href, impersonating));
      }}
      className={`fixed bottom-[calc(max(1rem,env(safe-area-inset-bottom))+4.75rem)] right-4 z-40 rounded-md px-4 py-2.5 text-sm font-semibold shadow-lg sm:bottom-[6.75rem] sm:right-6 ${
        complete
          ? 'bg-red-700 text-white hover:bg-red-600'
          : 'cursor-not-allowed bg-gray-200 text-gray-400 dark:bg-gray-700 dark:text-gray-500'
      }`}
    >
      Next Section
    </button>
  );
}
